import styled from 'styled-components';

export const Container = styled.div`
  & > .hefesto-side-sheet {
    & > .hefesto-side-sheet-container {
      width: 32rem;
    }
  }
`;

export const SkeletonContainer = styled.div`
  & > .hefesto-skeleton {
    margin-bottom: 1rem;
  }
`;

export const TextContainer = styled.div`
  font-size: 1rem;
`;

export const BoldText = styled.span`
  font-weight: bold;
`;

export const ChipsContainer = styled.div`
  & > .hefesto-chip {
    & > .mdc-chip-set {
      display: grid;
      grid-template-columns: 50% 50%;
      padding: 0;
      & > .mdc-chip {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
`;

export const ActionContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: 4rem;
  font-size: 1rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  width: 30rem;
  position: fixed;
  bottom: 0;
  padding: 0.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  gap: 1rem;
`;

export const CancelButtonContainer = styled.div`
  width: 50%;
`;

export const WarningText = styled.p`
  color: ${({ theme }) => theme.colors.red2};
`;
